// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"5d1eda31","321":"b02a13d1","552":"fef69973"}[chunkId] + ".chunk.js";
};